<template>
    <div class="ebooks" style="padding-bottom: 0;">
        <div class="container-fluid">
            <div class="row" >
                <div class="col-md-12" style="height: 100vh; padding: 0;">
                    <iframe :src="ebook_link"
                            frameborder="0" allowfullscreen width="100%" height="100%" referrerpolicy="origin"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {getEbookHome} from "../../models/dashboard";

    export default {
        name: "EbookHome",
        title: "iSMART eBook",
      data() {
        return this.initState();
      },
      created() {
        this.fetch();
      },
      methods: {
        fetch(){
          this.getEbooks()
        },
        initState() {
          return {
            ebook_link: '',
          };
        },
        async getEbooks() {
          const that = this;
          that.$store.commit("setLoading", true);
          const params = this.$route.query;
          await axios.all([
            getEbookHome(params)
          ]).then(axios.spread((ebook) => {
            that.$store.commit("setLoading", false);
            if (ebook.data.code == 0){
              that.ebook_link = ebook.data.results.url || '';
              console.log( that.ebook_link);
            }
          }));
        },
      }
    }
</script>

<style scoped>
</style>
